import moment from 'moment-timezone';
let momentInstance = moment.tz.setDefault('Asia/Dhaka');
export default momentInstance;